export default "__VITE_ASSET__DmKbnP0r__"